import { render } from "./MrFerry.vue?vue&type=template&id=04a4e8dd&scoped=true"
import script from "./MrFerry.vue?vue&type=script&lang=js"
export * from "./MrFerry.vue?vue&type=script&lang=js"

import "./MrFerry.vue?vue&type=style&index=0&id=04a4e8dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a4e8dd"]])

export default __exports__